import React, { useEffect, useState } from "react";
import t from "../assets/images/krinvy_team2.gif";
import axios from "axios";
import "./Careers.css";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import Cosection from "../components/Cosections";
import Scrolltop from "../components/Scrolltop";
import WhatsAppChatButton from "../components/Whatsapp";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import CareersFaqs from "../pages/CareersFaqs";
import toast from "react-hot-toast";

const Careers = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [resume, setResume] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("India");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!resume || resume.type !== "application/pdf") {
      alert("Please upload a valid PDF file.");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("resume", resume);
    formData.append("country", selectedCountry);
    formData.append("message", message);
    try {
      const response = await axios.post(
        "https://api.krinvy.com/api/uploadCareer",
        formData
      );
      if (response.data.success) {
        toast.success(response.data.message);
        setName("");
        setEmail("");
        setResume(null);
        setSelectedCountry("India");
        setMessage("");

        const resumeInput = document.getElementById("resume");
      if (resumeInput) {
        resumeInput.value = "";
      }
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      }
    }
  };

  return (
    <div>
      <Navigation />

      {/* Section 1 - Hero */}
      <div className="career-about-container">
        <div className="career-about-content">
          <div className="career-about-image">
            <img src={t} alt="Careers" className="career-img" />
          </div>
          <div className="career-about-text">
            <h1 className="career-heading">Join Our Team</h1>
            <p>
              Krinvy offers its employees freedom at work, opportunities to
              excel, and a supportive environment to achieve professional
              growth. We encourage active participation and value the input of
              all team members.
            </p>
            <p>
              If you are passionate about making a difference and exploring your
              potential, join us today!
            </p>
          </div>
        </div>
      </div>



      {/* Section 2 - Job Openings */}
      <div className="career-job-container">
        <div className="career-job-content">
          <h2 className="career-subheading">Job Openings</h2>

          <div className="career-job-grid">
            {/* India Positions */}
            <div className="career-job-region">
              <div className="career-region-header">
                <h3 className="career-region-title">India Positions</h3>
                <div className="career-region-flag">🇮🇳</div>
              </div>

              {/* Financial Services */}
              <div className="career-position">
                <h4 className="career-position-title">Tax Analyst (Fresher)</h4>
                <p className="career-position-desc">
                  Entry-level position in tax filings and compliance
                </p>
                <ul className="career-position-details">
                  <li>B.Com/M.Com/MBA Finance or equivalent</li>
                  <li>Basic knowledge of GST/Income Tax</li>
                  <li>Willingness to learn US tax processes</li>
                  <li>Strong analytical skills</li>
                  <li>Remote work opportunity</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Tax Specialist (1.5 years)
                </h4>
                <p className="career-position-desc">
                  Handle US/India tax filings with some experience
                </p>
                <ul className="career-position-details">
                  <li>1.5 years tax experience</li>
                  <li>Knowledge of GST/Income Tax or basic US tax</li>
                  <li>Proficiency in Tally/QuickBooks</li>
                  <li>Good communication skills</li>
                  <li>Remote position</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Senior Tax Analyst (3.5 years)
                </h4>
                <p className="career-position-desc">
                  Lead tax compliance projects
                </p>
                <ul className="career-position-details">
                  <li>3.5+ years tax experience</li>
                  <li>CA/CPA/MBA Finance preferred</li>
                  <li>Expertise in India or US tax systems</li>
                  <li>Team coordination skills</li>
                  <li>Full-time remote</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Payroll Executive (Fresher)
                </h4>
                <p className="career-position-desc">
                  Entry-level payroll processing
                </p>
                <ul className="career-position-details">
                  <li>B.Com/BBA or equivalent</li>
                  <li>Basic Excel skills</li>
                  <li>Attention to detail</li>
                  <li>Learn payroll software</li>
                  <li>Work from anywhere</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Payroll Specialist (2.5 years)
                </h4>
                <p className="career-position-desc">
                  Manage payroll operations
                </p>
                <ul className="career-position-details">
                  <li>2.5 years payroll experience</li>
                  <li>Knowledge of PF, ESI, PT regulations</li>
                  <li>Experience with payroll software</li>
                  <li>Problem-solving skills</li>
                  <li>Remote work setup</li>
                </ul>
              </div>

              {/* Digital Solutions */}
              <div className="career-position">
                <h4 className="career-position-title">
                  Junior Web Developer (Fresher)
                </h4>
                <p className="career-position-desc">
                  Build basic web applications
                </p>
                <ul className="career-position-details">
                  <li>HTML/CSS/JavaScript knowledge</li>
                  <li>Basic React understanding</li>
                  <li>Portfolio/projects preferred</li>
                  <li>Remote position</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Full Stack Developer (2.5 years)
                </h4>
                <p className="career-position-desc">Develop web applications</p>
                <ul className="career-position-details">
                  <li>2.5 years with React/Node.js</li>
                  <li>REST API development</li>
                  <li>Database knowledge</li>
                  <li>Full-time remote</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  AI Chatbot Developer (1.5 years)
                </h4>
                <p className="career-position-desc">
                  Create automated messaging solutions
                </p>
                <ul className="career-position-details">
                  <li>1.5 years Python/JavaScript</li>
                  <li>Dialogflow/Rasa experience</li>
                  <li>API integration knowledge</li>
                  <li>Work from home</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Senior IT Solutions Architect (5 years)
                </h4>
                <p className="career-position-desc">
                  Design enterprise solutions
                </p>
                <ul className="career-position-details">
                  <li>5+ years IT experience</li>
                  <li>Cloud architecture expertise</li>
                  <li>ERP/CRM implementation</li>
                  <li>Remote leadership role</li>
                </ul>
              </div>

              {/* Marketing */}
              <div className="career-position">
                <h4 className="career-position-title">
                  Digital Marketing Trainee (Fresher)
                </h4>
                <p className="career-position-desc">
                  Learn and execute campaigns
                </p>
                <ul className="career-position-details">
                  <li>Marketing degree preferred</li>
                  <li>Basic SEO/SEM knowledge</li>
                  <li>Content writing skills</li>
                  <li>Remote internship</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Social Media Manager (3.5 years)
                </h4>
                <p className="career-position-desc">
                  Lead social media strategies
                </p>
                <ul className="career-position-details">
                  <li>3.5 years experience</li>
                  <li>Content strategy expertise</li>
                  <li>Analytics proficiency</li>
                  <li>Work from anywhere</li>
                </ul>
              </div>

              {/* HR & Operations */}
              <div className="career-position">
                <h4 className="career-position-title">
                  HR Coordinator (1.5 years)
                </h4>
                <p className="career-position-desc">Support HR operations</p>
                <ul className="career-position-details">
                  <li>1.5 years HR experience</li>
                  <li>Recruitment coordination</li>
                  <li>Employee onboarding</li>
                  <li>Remote work setup</li>
                </ul>
              </div>
            </div>

            {/* US Positions */}
            <div className="career-job-region">
              <div className="career-region-header">
                <h3 className="career-region-title">US Positions</h3>
                <div className="career-region-flag">🇺🇸</div>
              </div>

              {/* Financial Services */}
              <div className="career-position">
                <h4 className="career-position-title">
                  Entry-Level Tax Preparer (Fresher)
                </h4>
                <p className="career-position-desc">
                  Beginner tax preparation role
                </p>
                <ul className="career-position-details">
                  <li>Accounting background</li>
                  <li>Willing to obtain EA credential</li>
                  <li>Basic 1040 knowledge</li>
                  <li>Remote training provided</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Enrolled Agent (3.5 years)
                </h4>
                <p className="career-position-desc">Lead US tax preparation</p>
                <ul className="career-position-details">
                  <li>Active EA credential</li>
                  <li>3.5+ years tax experience</li>
                  <li>Drake/UltraTax proficiency</li>
                  <li>Full-time remote</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">Tax Manager (5 years)</h4>
                <p className="career-position-desc">Oversee tax operations</p>
                <ul className="career-position-details">
                  <li>CPA license required</li>
                  <li>5+ years tax experience</li>
                  <li>Team management</li>
                  <li>Remote leadership role</li>
                </ul>
              </div>

              {/* Software Engineering */}
              <div className="career-position">
                <h4 className="career-position-title">
                  Junior React Developer (1.5 years)
                </h4>
                <p className="career-position-desc">
                  Build frontend components
                </p>
                <ul className="career-position-details">
                  <li>1.5 years React experience</li>
                  <li>JavaScript/TypeScript</li>
                  <li>Remote development team</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Senior Software Engineer (5 years)
                </h4>
                <p className="career-position-desc">
                  Develop financial applications
                </p>
                <ul className="career-position-details">
                  <li>5+ years full-stack</li>
                  <li>React/Node.js/AWS</li>
                  <li>API design expertise</li>
                  <li>Work from home</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  DevOps Engineer (3.5 years)
                </h4>
                <p className="career-position-desc">
                  Maintain cloud infrastructure
                </p>
                <ul className="career-position-details">
                  <li>3.5+ years DevOps</li>
                  <li>AWS/GCP experience</li>
                  <li>CI/CD pipeline</li>
                  <li>Remote position</li>
                </ul>
              </div>

              {/* Business Development */}
              <div className="career-position">
                <h4 className="career-position-title">
                  Business Development Associate (Fresher)
                </h4>
                <p className="career-position-desc">
                  Support sales initiatives
                </p>
                <ul className="career-position-details">
                  <li>Business degree preferred</li>
                  <li>Communication skills</li>
                  <li>Remote sales support</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">BD Manager (5 years)</h4>
                <p className="career-position-desc">Expand US client base</p>
                <ul className="career-position-details">
                  <li>5+ years B2B sales</li>
                  <li>Accounting services experience</li>
                  <li>Proven sales track record</li>
                  <li>Remote with travel</li>
                </ul>
              </div>

              {/* Marketing */}
              <div className="career-position">
                <h4 className="career-position-title">
                  Content Writer (2.5 years)
                </h4>
                <p className="career-position-desc">Create marketing content</p>
                <ul className="career-position-details">
                  <li>2.5+ years writing experience</li>
                  <li>Finance/tax knowledge</li>
                  <li>SEO understanding</li>
                  <li>Work from home</li>
                </ul>
              </div>

              <div className="career-position">
                <h4 className="career-position-title">
                  Graphic Designer (3.5 years)
                </h4>
                <p className="career-position-desc">Create visual assets</p>
                <ul className="career-position-details">
                  <li>3.5+ years design experience</li>
                  <li>Adobe Creative Suite</li>
                  <li>Branding expertise</li>
                  <li>Remote creative work</li>
                </ul>
              </div>

              {/* Legal */}
              <div className="career-position">
                <h4 className="career-position-title">
                  Legal Compliance Specialist (5 years)
                </h4>
                <p className="career-position-desc">
                  Ensure regulatory compliance
                </p>
                <ul className="career-position-details">
                  <li>JD or legal background</li>
                  <li>5+ years compliance</li>
                  <li>US business regulations</li>
                  <li>Remote advisory role</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3 - Application Form */}
      <div className="career-form-container">
        <div className="career-form-content">
          <h2 className="career-subheading">Upload Resume to Apply</h2>
          <form className="career-resume-form" onSubmit={handleSubmit}>
            <div className="career-form-row">
              <div className="career-form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="career-form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="career-form-group">
              <label htmlFor="country">Location Preference:</label>
              <select
                id="country"
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
                required
              >
                <option value="India">India</option>
                <option value="US">United States</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="career-form-group">
              <label htmlFor="resume">Upload Resume (PDF only):</label>
              <input
                type="file"
                id="resume"
                onChange={(e) => setResume(e.target.files[0])}
                accept=".pdf"
                required
              />
            </div>

            <div className="career-form-group">
              <label htmlFor="message">Cover Letter/Message:</label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={4}
                placeholder="Tell us why you'd be a great fit..."
              />
            </div>

            <div className="career-notice">
              <h4>Important notice for candidates:</h4>
              <p>
                Job scams are on the rise. Please keep these guidelines in mind
                when applying for any open roles.
              </p>
              <ul>
                <li>
                  Only apply through official Krinvy channels. We don't use any
                  third-party services or platforms for our recruitment.
                </li>
                <li>
                  Always double-check the emails you receive. Make sure all
                  communications are being done through official Krinvy emails,
                  with an @krinvy.com domain.
                </li>
              </ul>
              <p>
                We won't ask for payment or personal financial information
                during the hiring process. If anyone does ask you for this, it's
                a scam. Report it immediately.
              </p>
              <p className="career-disclaimer">
                By submitting this application, I confirm that all the
                information given by me in this application for employment and
                any additional documents attached hereto are true to the best of
                my knowledge and that I have not wilfully suppressed any
                material fact. I confirm I have disclosed if applicable any
                previous employment with Krinvy. I accept that if any of the
                information given by me in this application is in any way false
                or incorrect, my application may be rejected, any offer of
                employment may be withdrawn or my employment with Krinvy may be
                terminated summarily or I may be dismissed. By submitting this
                application, I agree that my personal data will be processed in
                accordance with Krinvy's Candidate Privacy Notice.
              </p>
            </div>

            <button type="submit" className="career-upload-btn">
              Submit Application
            </button>
          </form>
        </div>
      </div>

      <CareersFaqs />
      <Scrolltop />
      <WhatsAppChatButton />

      <Footer />
    </div>
  );
};

export default Careers;
